<script lang="ts">
    import { clientCode } from "$lib/stores/store";
    import FooterCmu from "../section/Footer/catchmeup/FooterCMU.svelte";
    import FooterCommon from "../section/Footer/common/FooterCommon.svelte";

    const clientCodeUpdate = $clientCode;
    export let data: any = [];
    export let noFooter: any = "";
    const client = data;
</script>

{#if client?.code === "catchmeup"}
    <FooterCmu {client} />
{:else}
    <FooterCommon {noFooter} {client} />
{/if}
